/*=========================================================================================
  File Name: moduleEmailState.js
  Description: Email Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  devices: [],
  sets: [],
  cameras: [],
  all_cameras: [],
  accessPointCamSets: [],
  edit_set_data: null,
  cctv_selected_cameras: [],
  cctv_camera_headers: [
    {
      headerName: "Chanel #",
      field: "service_id",
      filter: true,

      checkboxSelection: true,
      // pinned: "left",
      // lockPinned: true,
      // lockPosition: "left",
      // cellClass: "locked-col",
      minWidth: 140,
      width: 140,
      suppressSizeToFit: true,
    },
    {
      headerName: "Name",
      field: "name",
      filter: true,

      minWidth: 90,
      width: 90,

    },
    {
      headerName: "Device",
      field: "device_type_name",
      filter: true,

      minWidth: 90,
      width: 90,
    },
    {
      headerName: "IP Address",
      field: "connection_type",
      filter: true,

      minWidth: 70,
      width: 70,
    },
    {
      headerName: "Port",
      field: "port",
      filter: true,

      minWidth: 60,
      width: 60,
    },
    {
      headerName: "View",
      field: "view",
      filter: true,

      cellRendererFramework: "CellRendererCameraView",
      minWidth: 50,
      width: 50,
    },

    {
      headerName: "Actions",
      field: "actions",

      cellRendererFramework: "CellRendererCctvCameraActions",
      filter: false,
      // pinned: "right",
      // lockPinned: true,
      // lockPosition: "right",
      // cellClass: "locked-col",
      maxWidth: 170,
      minWidth: 170,
      width: 170,
      cellStyle: { 'text-align': 'right', 'padding-right': '0px' },
      // suppressSizeToFit: true,
    },
  ],
  set_camera_headers: [
    {
      headerName: "Chanel #",
      field: "service_id",
      filter: true,

      // pinned: "left",
      // lockPinned: true,
      // lockPosition: "left",
      // cellClass: "locked-col",
      minWidth: 140,
      width: 140,
      suppressSizeToFit: true,
    },
    {
      headerName: "Name",
      field: "name",
      filter: true,
      cellRendererFramework: "CellRendererCameraName",

      minWidth: 90,
      width: 90,
    },
    {
      headerName: "Device",
      field: "device_type_name",
      filter: true,

      minWidth: 90,
      width: 90,
    },
    {
      headerName: "IP Address",
      field: "connection_type",
      filter: true,

      minWidth: 70,
      width: 70,
    },
    {
      headerName: "Port",
      field: "port",
      filter: true,

      minWidth: 60,
      width: 60,
    },
    {
      headerName: "View",
      field: "view",
      filter: true,

      cellRendererFramework: "CellRendererCameraView",
      minWidth: 50,
      width: 50,
    },
    {
      headerName: "Actions",
      field: "actions",

      cellRendererFramework: "CellRendererSetCameraActions",
      filter: false,
      maxWidth: 170,
      minWidth: 170,
      width: 170,
      // pinned: "right",
      // lockPinned: true,
      // lockPosition: "right",
      // cellClass: "locked-col",
      // maxWidth: 200,
      // minWidth: 200,
      // width: 200,
    },
  ]
};
